// TODO: customize
import {styled} from '@mui/material/styles';

/**
 * NOTE: Converted flatpickr to CSS ---> SCSS ---> JSON Object
 * Helpful links:
 * - CSS TO SCSS: https://css2sass.herokuapp.com/
 * - CSS TO JSON: https://transform.tools/css-to-js
 */

export const DefaultFlatpickrStyles = styled('div')({
    '.flatpickr-calendar': {
        background: 'transparent',
        opacity: 0,
        display: 'none',
        textAlign: 'center',
        visibility: 'hidden',
        padding: '0',
        WebkitAnimation: 'none',
        animation: 'none',
        direction: 'ltr',
        border: '0',
        fontSize: '14px',
        lineHeight: '24px',
        // borderRadius: '5px',
        position: 'absolute',
        // width: '307.875px',
        WebkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        msTouchAction: 'manipulation',
        touchAction: 'manipulation',
        // WebkitBoxShadow: '0 3px 13px rgba(0, 0, 0, 0.08)',
        // boxShadow: '0 3px 13px rgba(0, 0, 0, 0.08)',

        '&.open, &.inline': {
            opacity: 1,
            // maxHeight: '640px',
            visibility: 'visible'
        },
        '&.open': {
            display: 'inline-block',
            zIndex: 99999
        },
        '&.animate.open': {
            WebkitAnimation: 'fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1)',
            animation: 'fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1)'
        },
        '&.inline': {
            display: 'block',
            position: 'relative'
            // top: '2px'
        },
        '&.static': {
            position: 'absolute',
            // top: 'calc(100% + 2px)',
            '&.open': {
                zIndex: 999,
                display: 'block'
            }
        },
        // '&.multiMonth .flatpickr-days .dayContainer': {
        //     '&:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7)': {
        //         WebkitBoxShadow: 'none !important',
        //         boxShadow: 'none !important'
        //     },
        //     '&:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1)': {
        //         WebkitBoxShadow: '-2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6',
        //         boxShadow: '-2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6'
        //     }
        // },
        // '.hasWeeks .dayContainer, .hasTime .dayContainer': {
        //     borderBottom: '0',
        //     borderBottomRightRadius: '0',
        //     borderBottomLeftRadius: '0'
        // },
        '.hasWeeks .dayContainer': {
            borderLeft: '0'
        },
        '&.hasTime': {
            '.flatpickr-time': {
                // height: '40px'
                // borderTop: '1px solid #eceef1',
                // border: '1px solid #eceef1'
            }
            // '.flatpickr-innerContainer': {
            //     borderBottom: '0'
            // }
        },
        '&.noCalendar.hasTime .flatpickr-time': {
            height: 'auto'
        },
        // '&:before, &:after': {
        //     position: 'absolute',
        //     display: 'block',
        //     pointerEvents: 'none',
        //     border: 'solid transparent',
        //     content: "''",
        //     height: '0',
        //     width: '0',
        //     left: '22px'
        // },
        // '&.rightMost:before, &.arrowRight:before, &.rightMost:after, &.arrowRight:after': {
        //     left: 'auto',
        //     right: '22px'
        // },
        // '&.arrowCenter': {
        //     '&:before, &:after': {
        //         left: '50%',
        //         right: '50%'
        //     }
        // },
        // '&:before': {
        //     borderWidth: '5px',
        //     margin: '0 -5px'
        // },
        // '&:after': {
        //     borderWidth: '4px',
        //     margin: '0 -4px'
        // },
        // '&.arrowTop': {
        //     '&:before, &:after': {
        //         bottom: '100%',
        //         borderBottomColor: '#eceef1'
        //     }
        // },
        // '&.arrowBottom': {
        //     '&:before, &:after': {
        //         top: '100%',
        //         borderTopColor: '#eceef1'
        //     }
        // },
        '&:focus': {
            outline: '0'
        }
    },
    '.flatpickr-wrapper': {
        position: 'relative',
        display: 'inline-block'
    },
    '.flatpickr-months': {
        display: ['-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
        '.flatpickr-month': {
            // borderRadius: '5px 5px 0 0',
            // background: '#eceef1',
            // color: '#5a6171',
            fill: '#5a6171',
            // height: '34px',
            lineHeight: 1,
            textAlign: 'center',
            position: 'relative',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            overflow: 'hidden',
            WebkitBoxFlex: '1',
            WebkitFlex: '1',
            msFlex: '1',
            flex: 1
        },
        '.flatpickr-prev-month, .flatpickr-next-month': {
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            textDecoration: 'none',
            cursor: 'pointer',
            // position: 'absolute',
            top: '0',
            // height: '34px',
            // padding: '10px',
            zIndex: 3
            // color: '#5a6171',
            // fill: '#5a6171'
        },
        '.flatpickr-prev-month.flatpickr-disabled, .flatpickr-next-month.flatpickr-disabled': {
            display: 'none'
        },
        '.flatpickr-prev-month i, .flatpickr-next-month i': {
            position: 'relative'
        },
        '.flatpickr-prev-month.flatpickr-prev-month': {
            left: '0'
        },
        '.flatpickr-next-month': {
            '&.flatpickr-prev-month': {
                left: '0',
                right: '0'
            },
            '&.flatpickr-next-month': {
                right: '0'
            }
        },
        '.flatpickr-prev-month:hover, .flatpickr-next-month:hover': {
            color: '#bbb'
        },
        '.flatpickr-prev-month:hover svg, .flatpickr-next-month:hover svg': {
            fill: '#f64747'
        },
        '.flatpickr-prev-month svg, .flatpickr-next-month svg': {
            width: '14px',
            height: '14px'
        },
        '.flatpickr-prev-month svg path, .flatpickr-next-month svg path': {
            WebkitTransition: 'fill 0.1s',
            transition: 'fill 0.1s',
            fill: 'inherit'
        }
    },
    '.numInputWrapper': {
        position: 'relative',
        height: 'auto',
        'input, span': {
            display: 'inline-block'
        },
        input: {
            width: '100%',
            '&::-ms-clear': {
                display: 'none'
            },
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                margin: '0',
                WebkitAppearance: 'none'
            }
        },
        span: {
            position: 'absolute',
            right: '0',
            width: '14px',
            // padding: '0 4px 0 2px',
            height: '50%',
            lineHeight: '50%',
            opacity: 0,
            cursor: 'pointer',
            border: '1px solid rgba(72, 72, 72, 0.15)',
            WebkitBoxSizing: 'border-box',
            boxSizing: 'border-box',
            '&:hover': {
                background: 'rgba(0, 0, 0, 0.1)'
            },
            '&:active': {
                background: 'rgba(0, 0, 0, 0.2)'
            }
            // '&:after': {
            //     display: 'block',
            //     content: '""',
            //     position: 'absolute'
            // },
            // '&.arrowUp': {
            // top: '0',
            // borderBottom: '0',
            // '&:after': {
            //     borderLeft: '4px solid transparent',
            //     borderRight: '4px solid transparent',
            //     borderBottom: '4px solid rgba(72, 72, 72, 0.6)',
            //     top: '26%'
            // }
            // },
            // '&.arrowDown': {
            //     top: '50%',
            //     '&:after': {
            //         borderLeft: '4px solid transparent',
            //         borderRight: '4px solid transparent',
            //         borderTop: '4px solid rgba(72, 72, 72, 0.6)',
            //         top: '40%'
            //     }
            // },
            // svg: {
            //     width: 'inherit',
            //     height: 'auto',
            //     path: {
            //         fill: 'rgba(90, 97, 113, 0.5)'
            //     }
            // }
        },
        '&:hover': {
            background: 'rgba(0, 0, 0, 0.05)',
            span: {
                opacity: 1
            }
        }
    },
    '.flatpickr-current-month': {
        fontSize: '135%',
        lineHeight: ['inherit', 1],
        fontWeight: 300,
        color: 'inherit',
        // position: 'absolute',
        // width: '75%',
        // left: '12.5%',
        // padding: '7.48px 0 0 0',
        // height: '34px',
        display: 'inline-block',
        textAlign: 'center',
        WebkitTransform: 'translate3d(0px, 0px, 0px)',
        transform: 'translate3d(0px, 0px, 0px)',
        // 'span.cur-month': {
        //     fontFamily: 'inherit',
        //     fontWeight: 700,
        //     color: 'inherit',
        //     display: 'inline-block',
        //     // marginLeft: '0.5ch',
        //     padding: '0',
        //     '&:hover': {
        //         background: 'rgba(0, 0, 0, 0.05)'
        //     }
        // },
        '.numInputWrapper': {
            // width: ['6ch', '7ch\\0'],
            display: 'inline-block',
            span: {
                '&.arrowUp:after': {
                    borderBottomColor: '#5a6171'
                },
                '&.arrowDown:after': {
                    borderTopColor: '#5a6171'
                }
            }
        },
        'input.cur-year': {
            background: 'transparent',
            WebkitBoxSizing: 'border-box',
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'text',
            // padding: '0 0 0 0.5ch',
            margin: '0',
            display: 'inline-block',
            fontSize: 'inherit',
            fontFamily: 'inherit',
            // fontWeight: 300,
            lineHeight: 'inherit',
            height: 'auto',
            border: '0',
            borderRadius: '0',
            verticalAlign: 'initial',
            WebkitAppearance: 'textfield',
            MozAppearance: 'textfield',
            appearance: 'textfield',
            '&:focus': {
                outline: '0'
            },
            '&[disabled]': {
                fontSize: '100%',
                color: 'rgba(90, 97, 113, 0.5)',
                background: 'transparent',
                pointerEvents: 'none',
                '&:hover': {
                    fontSize: '100%',
                    color: 'rgba(90, 97, 113, 0.5)',
                    background: 'transparent',
                    pointerEvents: 'none'
                }
            }
        },
        '.flatpickr-monthDropdown-months': {
            appearance: 'menulist',
            // background: '#eceef1',
            border: 'none',
            borderRadius: '0',
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: 'inherit',
            fontFamily: 'inherit',
            // fontWeight: 300,
            height: 'auto',
            lineHeight: 'inherit',
            // margin: '-1px 0 0 0',
            outline: 'none',
            // padding: '0 0 0 0.5ch',
            position: 'relative',
            verticalAlign: 'initial',
            WebkitBoxSizing: 'border-box',
            WebkitAppearance: 'menulist',
            MozAppearance: 'menulist',
            width: 'auto',
            '&:focus, &:active': {
                outline: 'none'
            },
            '&:hover': {
                background: 'rgba(0, 0, 0, 0.05)'
            },
            '.flatpickr-monthDropdown-month': {
                backgroundColor: '#eceef1',
                outline: 'none',
                padding: '0'
            }
        }
    },
    '.flatpickr-weekdays': {
        // background: '#eceef1',
        textAlign: 'center',
        overflow: 'hidden',
        width: '100%',
        display: ['-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
        WebkitBoxAlign: 'center',
        WebkitAlignItems: 'center',
        msFlexAlign: 'center',
        alignItems: 'center',
        // height: '28px',

        '.flatpickr-weekdaycontainer': {
            display: ['-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
            WebkitBoxFlex: '1',
            WebkitFlex: '1',
            msFlex: '1',
            flex: 1
        }
    },
    'span.flatpickr-weekday': {
        cursor: 'default',
        // fontSize: '90%',
        // background: '#eceef1',
        // color: '#5a6171',
        lineHeight: 1,
        margin: '0',
        textAlign: 'center',
        display: 'block',
        WebkitBoxFlex: '1',
        WebkitFlex: '1',
        msFlex: '1',
        // flex: 1,
        fontWeight: 'bolder'
    },
    '.dayContainer, .flatpickr-weeks': {
        // padding: '1px 0 0 0'
    },
    '.flatpickr-days': {
        position: 'relative',
        overflow: 'hidden',
        display: ['-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
        WebkitBoxAlign: 'start',
        WebkitAlignItems: 'flex-start',
        msFlexAlign: 'start',
        alignItems: 'flex-start',
        // width: '307.875px',
        // borderLeft: '1px solid #eceef1',
        // borderRight: '1px solid #eceef1',
        '&:focus': {
            outline: '0'
        }
    },
    '.dayContainer': {
        padding: '0',
        outline: '0',
        textAlign: 'left',
        // width: '307.875px',
        // minWidth: '307.875px',
        // maxWidth: '307.875px',
        // WebkitBoxSizing: 'border-box',
        // boxSizing: 'border-box',
        // display: [
        //     'inline-block',
        //     '-ms-flexbox',
        //     '-webkit-box',
        //     '-webkit-flex',
        //     'flex'
        // ],
        WebkitFlexWrap: 'wrap',
        flexWrap: 'wrap',
        msFlexWrap: 'wrap',
        // msFlexPack: 'justify',
        // WebkitJustifyContent: 'space-around',
        // justifyContent: 'space-around',
        WebkitTransform: 'translate3d(0px, 0px, 0px)',
        transform: 'translate3d(0px, 0px, 0px)'
        // opacity: 1,
        // '+ .dayContainer': {
        //     WebkitBoxShadow: '-1px 0 0 #eceef1',
        //     boxShadow: '-1px 0 0 #eceef1'
        // }
    },
    '.flatpickr-day': {
        background: 'none',
        border: '1px solid transparent',
        borderRadius: '150px',
        WebkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        // color: '#484848',
        cursor: 'pointer',
        fontWeight: 400,
        // width: '14.2857143%',
        // WebkitFlexBasis: '14.2857143%',
        // msFlexPreferredSize: '14.2857143%',
        // flexBasis: '14.2857143%',
        // maxWidth: '39px',
        // height: '39px',
        // lineHeight: '39px',
        margin: '0',
        // display: 'inline-block',
        // position: 'relative',
        // WebkitBoxPack: 'center',
        // WebkitJustifyContent: 'center',
        msFlexPack: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        '&.inRange, &.prevMonthDay.inRange, &.nextMonthDay.inRange, &.today.inRange, &.prevMonthDay.today.inRange, &.nextMonthDay.today.inRange, &:hover, &.prevMonthDay:hover, &.nextMonthDay:hover, &:focus, &.prevMonthDay:focus, &.nextMonthDay:focus': {
            cursor: 'pointer',
            outline: '0',
            background: '#e2e2e2',
            borderColor: '#e2e2e2'
        },
        '&.today': {
            borderColor: '#bbb',
            '&:hover, &:focus': {
                borderColor: '#bbb',
                background: '#bbb',
                color: '#fff'
            }
        },
        // '&.selected, &.startRange, &.endRange, &.selected.inRange, &.startRange.inRange, &.endRange.inRange, &.selected:focus, &.startRange:focus, &.endRange:focus, &.selected:hover, &.startRange:hover, &.endRange:hover, &.selected.prevMonthDay, &.startRange.prevMonthDay, &.endRange.prevMonthDay, &.selected.nextMonthDay, &.startRange.nextMonthDay, &.endRange.nextMonthDay': {
        //     background: '#ff5a5f',
        //     WebkitBoxShadow: 'none',
        //     boxShadow: 'none',
        //     color: '#fff',
        //     borderColor: '#ff5a5f'
        // },
        '&.selected.startRange, &.startRange.startRange, &.endRange.startRange': {
            borderRadius: '50px 0 0 50px'
        },
        '&.selected.endRange, &.startRange.endRange, &.endRange.endRange': {
            borderRadius: '0 50px 50px 0'
        },
        // '&.selected.startRange + .endRange:not(:nth-child(7n+1)), &.startRange.startRange + .endRange:not(:nth-child(7n+1)), &.endRange.startRange + .endRange:not(:nth-child(7n+1))': {
        //     WebkitBoxShadow: '-10px 0 0 #ff5a5f',
        //     boxShadow: '-10px 0 0 #ff5a5f'
        // },
        '&.selected.startRange.endRange, &.startRange.startRange.endRange': {
            borderRadius: '50px'
        },
        '&.inRange': {
            borderRadius: '0'
            // WebkitBoxShadow: '-5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2',
            // boxShadow: '-5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2'
        },
        // '&.flatpickr-disabled': {
        //     color: 'rgba(72, 72, 72, 0.1)',
        //     background: 'transparent',
        //     borderColor: 'transparent',
        //     cursor: 'not-allowed',
        //     '&:hover': {
        //         cursor: 'not-allowed',
        //         color: 'rgba(72, 72, 72, 0.1)'
        //     }
        // },
        '&.prevMonthDay, &.nextMonthDay': {
            color: 'rgba(72, 72, 72, 0.3)',
            background: 'transparent',
            borderColor: 'transparent',
            cursor: 'default'
        },
        '&.notAllowed': {
            color: 'rgba(72, 72, 72, 0.3)',
            background: 'transparent',
            borderColor: 'transparent',
            cursor: 'default',
            '&.prevMonthDay, &.nextMonthDay': {
                color: 'rgba(72, 72, 72, 0.3)',
                background: 'transparent',
                borderColor: 'transparent',
                cursor: 'default'
            }
        },
        // '&.week.selected': {
        //     borderRadius: '0',
        //     WebkitBoxShadow: '-5px 0 0 #ff5a5f, 5px 0 0 #ff5a5f',
        //     boxShadow: '-5px 0 0 #ff5a5f, 5px 0 0 #ff5a5f'
        // },
        '&.hidden': {
            visibility: 'hidden'
        }
    },
    // '.rangeMode .flatpickr-day': {
    //     marginTop: '1px'
    // },
    '.flatpickr-weekwrapper': {
        cssFloat: 'left',
        '.flatpickr-weeks': {
            padding: '0 12px',
            borderLeft: '1px solid #eceef1'
        },
        '.flatpickr-weekday': {
            cssFloat: 'none',
            width: '100%',
            lineHeight: '28px'
        },
        'span.flatpickr-day': {
            display: 'block',
            width: '100%',
            maxWidth: 'none',
            color: 'rgba(72, 72, 72, 0.3)',
            background: 'transparent',
            cursor: 'default',
            border: 'none',
            '&:hover': {
                display: 'block',
                width: '100%',
                maxWidth: 'none',
                color: 'rgba(72, 72, 72, 0.3)',
                background: 'transparent',
                cursor: 'default',
                border: 'none'
            }
        }
    },
    '.flatpickr-innerContainer': {
        display: ['block', '-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
        WebkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        overflow: 'hidden',
        background: '#fff'
        // borderBottom: '1px solid #eceef1'
    },
    '.flatpickr-rContainer': {
        // display: 'inline-block',
        padding: '0',
        WebkitBoxSizing: 'border-box',
        boxSizing: 'border-box'
    },
    '.flatpickr-time': {
        textAlign: 'center',
        outline: '0',
        display: ['block', '-webkit-box', '-webkit-flex', '-ms-flexbox', 'flex'],
        height: '0',
        lineHeight: '40px',
        maxHeight: '40px',
        WebkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        overflow: 'hidden',
        background: '#fff',
        borderRadius: '0 0 5px 5px',
        // '&:after': {
        //     content: '""',
        //     display: 'table',
        //     clear: 'both'
        // },
        '.numInputWrapper': {
            WebkitBoxFlex: '1',
            WebkitFlex: '1',
            msFlex: '1',
            flex: 1,
            width: '40%',
            height: '40px',
            cssFloat: 'left',
            span: {
                '&.arrowUp:after': {
                    borderBottomColor: '#484848'
                },
                '&.arrowDown:after': {
                    borderTopColor: '#484848'
                }
            }
        },
        '&.hasSeconds .numInputWrapper': {
            width: '26%'
        },
        '&.time24hr .numInputWrapper': {
            width: '49%'
        },
        input: {
            background: 'transparent',
            WebkitBoxShadow: 'none',
            boxShadow: 'none',
            border: '0',
            borderRadius: '0',
            textAlign: 'center',
            margin: '0',
            padding: '0',
            height: 'inherit',
            lineHeight: 'inherit',
            color: '#484848',
            fontSize: '14px',
            position: 'relative',
            WebkitBoxSizing: 'border-box',
            boxSizing: 'border-box',
            WebkitAppearance: 'textfield',
            MozAppearance: 'textfield',
            appearance: 'textfield',
            '&.flatpickr-hour': {
                fontWeight: 'bold'
            },
            '&.flatpickr-minute, &.flatpickr-second': {
                fontWeight: 400
            },
            '&:focus': {
                outline: '0',
                border: '0'
            }
        },
        '.flatpickr-time-separator': {
            height: 'inherit',
            cssFloat: 'left',
            lineHeight: 'inherit',
            color: '#484848',
            fontWeight: 'bold',
            width: '2%',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            WebkitAlignSelf: 'center',
            msFlexItemAlign: 'center',
            alignSelf: 'center'
        },
        '.flatpickr-am-pm': {
            height: 'inherit',
            cssFloat: 'left',
            lineHeight: 'inherit',
            color: '#484848',
            fontWeight: ['bold', 400],
            width: ['2%', '18%'],
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            WebkitAlignSelf: 'center',
            msFlexItemAlign: 'center',
            alignSelf: 'center',
            outline: '0',
            cursor: 'pointer',
            textAlign: 'center'
        },
        'input:hover, .flatpickr-am-pm:hover, input:focus, .flatpickr-am-pm:focus': {
            background: '#eaeaea'
        }
    },
    '.flatpickr-input[readonly]': {
        cursor: 'pointer'
    },
    '@-webkit-keyframes fpFadeInDown': {
        from: {
            opacity: 0,
            WebkitTransform: 'translate3d(0, -20px, 0)',
            transform: 'translate3d(0, -20px, 0)'
        },
        to: {
            opacity: 1,
            WebkitTransform: 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)'
        }
    },
    '@keyframes fpFadeInDown': {
        from: {
            opacity: 0,
            WebkitTransform: 'translate3d(0, -20px, 0)',
            transform: 'translate3d(0, -20px, 0)'
        },
        to: {
            opacity: 1,
            WebkitTransform: 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)'
        }
    }
    // 'span.flatpickr-day.selected': {
    //     fontWeight: 'bold'
    // }
}
);
